
import { canonical } from "@utils";
import { AD_LAYOUT_STUBS, AD_PLACEMENTS } from "@consts";

export default {
	name: "GameCheats",
	data() {
		return {
			AD_LAYOUT_STUBS,
			AD_PLACEMENTS,
			primaryGames: [
				{
					title: "Scrabble Word Finder",
					description:
						"Let’s find your words. For Scrabble. It’s basically our whole thing: and we do it quickly for you, too!",
					url: "/",
					image: "/static/images/game-cheats/im-scrabble@2x.jpg",
				},
				{
					title: "Words With Friends Cheat",
					description:
						"Using this Words With Friends cheat tool is not cheating; it’s a little help from your friends. That’s why it’s in the title. ",
					url: "/words-with-friends-cheat/",
					image: "/static/images/game-cheats/im-wwf@2x.jpg",
				},
				{
					title: "Wordle Solver",
					description:
						"Get the green every time. Solve the daily Wordle puzzle with the best helper and keep your win streak going strong.",
					url: "/wordle/",
					image: "/static/images/game-cheats/im-wordle@2x.jpg",
				},
				{
					title: "Wordscapes Answers & Cheat",
					description:
						"All the answers for Wordscapes. Including daily puzzles and bonus words.",
					url: "https://wordscapes.yourdictionary.com/",
					external: true,
					image: "/static/images/game-cheats/im-ws@2x.jpg",
				},
			],
			secondaryGames: [
				{
					title: "Word Unscrambler",
					description:
						"Rearrange letters and unscramble the winning (valid) word with our easy-to-use word unscrambler.",
					url: "/unscramble/",
				},

				{
					title: "Anagram Solver",
					description:
						"Get ready to input letters and unscramble them in no time with our anagram solver.",
					url: "/anagram-solver/",
				},

				{
					title: "Today’s Wordle Answer &  Hints",
					description:
						"Having trouble finding the answer to today’s Wordle? Our daily Wordle hints can point you in the right direction.",
					url: "/wordle/hints/",
				},

				{
					title: "Word Scramble",
					description:
						"Unscramble the scramblest of scrambled words with our tool! Also, never use the word “scramblest.” It's not real.",
					url: "/word-scramble/",
				},

				{
					title: "List of Wordle Answers",
					description:
						"Today’s Wordle answer is here, plus a full archive of all daily Wordle solutions before it. Just in case.",
					url: "/wordle/answers/",
				},

				{
					title: "4 Pics 1 Word Answers",
					description:
						"Find all the 4 Pics 1 Word game answers you need, and give your eyes a break from the confused staring.",
					url: "/4pics1word/",
				},

				{
					title: "Scrabble Cheat",
					description:
						"Maximize your Scrabble score by finding the best possible word combinations your letters can make.",
					url: "/scrabble-dictionary/",
				},

				{
					title: "Word Maker",
					description:
						"Your brain needs a break. Make words with our word maker instead! Quickly and conveniently.",
					url: "/word-maker/",
				},

				{
					title: "Jumble Solver",
					description:
						"Jumble word puzzles got you down? Our jumble solver will pick you right back up victoriously.",
					url: "/jumble-solver/",
				},

				{
					title: "NYT Connections Hints & Answers",
					description:
						"It’s innovative. It’s interactive. It’s the best way to ensure you never lose your winning streak. Beat NYT Connections every time.",
					url: "/nyt-connections/",
				},

				{
					title: "Words with Letters and a Blank",
					description:
						"Fill in those blanks in your words with the type of a keyboard. Get stumped, input, and you’re done!",
					url: "/words-with-letters-blank/",
				},

				{
					title: "Scrabble Dictionary Checker",
					description:
						"The definitive word game dictionary. Just input your letters, and watch the words come to you.",
					url: "/scrabble-dictionary/",
				},

				{
					title: "Quordle Solver",
					description:
						"Four words? Zero problems. Solve all four daily Quordle answers swiftly.",
					url: "/quordle/",
				},

				{
					title: "Random Word Generator",
					description:
						"Need a word? Any word? Good thing we’ve got a tool for that. Just tell us how long it needs to be and we’ll give you a list.",
					url: "/random-word-generator/",
				},

				{
					title: "Spelling Bee Answers",
					description:
						"Be a Queen Bee and buzz your way to success with our up-to-date NYT Spelling Bee answers page, conveniently arranged.",
					url: "/nyt-spelling-bee/",
				},

				{
					title: "Crossword Solver",
					description:
						"No, your crossword won’t get the better of you. Not if our easy-to-use solver tool has anything to say about it.",
					url: "/crosswords/",
				},

				{
					title: "Word Descrambler",
					description:
						"Pop your letters into our tool and watch it descramble them for you. Like magic! (Except it’s technology.)",
					url: "/word-descrambler/",
				},

				{
					title: "Word Connect Answers",
					description:
						"Save your coins. We’ve got you covered with more than just a hint: we’ve got a whole Word Connect solver.",
					url: "/word-connect-answers/",
				},

				{
					title: "Word Chums Cheat",
					description:
						"Take victory in Word Chums by entering your letter tiles and finding every possible word.",
					url: "/word-chums-cheat/",
				},

				{
					title: "Word Wars Cheat",
					description:
						"Those letters may have won the battle, but they’ll never win the Word War. Not while our solver tool’s around.",
					url: "/word-wars/",
				},

				{
					title: "Word Cookies! Cheat",
					description:
						"Not feeling clever today? Happens to everyone. Find Word Cookies answers quickly with our cheat tool. ",
					url: "/word-cookies/",
				},

				{
					title: "Scrabble GO Word Checker",
					description:
						"Never fear, our Scrabble checker is here! You know, so you can make sure the word you’re making counts.",
					url: "/scrabble-checker/",
				},

				{
					title: "CodyCross Answers",
					description:
						"CodyCross got you cross? Unlike the pun, our solver tool works. Stop getting cross; start getting answers.",
					url: "/codycross-answers/",
				},

				{
					title: "Words Story Cheat",
					description:
						"Find the answers to Words Story and advance the plot before the stickman gets stuck in jail! Poor guy.",
					url: "/words-story-answers/",
				},

				{
					title: "WordBrain Answers",
					description:
						"Training your brain with WordBrain? Everyone can use a cheat day with a cheat tool!",
					url: "/wordbrain-answers/",
				},

				{
					title: "Wordfeud Cheat",
					description:
						"It’s time to end the feud with Wordfeud. Simply ask for the help we provide and find victory.",
					url: "/wordfeud-helper/",
				},

				{
					title: "Text Twist Solver",
					description:
						"The clock is ticking, and Text Twist is running in the background. Open our solver and start winning.",
					url: "/text-twist/",
				},

				{
					title: "Word Swipe Answers",
					description:
						"Learn how to beat Word Swipe and its creative mix of strategies with some cheats we love to provide.",
					url: "/word-swipe-cheats/",
				},
			],
		};
	},
	head() {
		return {
			link: [canonical(this.$route)],
		};
	},
};
